import { render, staticRenderFns } from "./MyActiveTasks.vue?vue&type=template&id=73c325f7&scoped=true"
import script from "./MyActiveTasks.vue?vue&type=script&lang=js"
export * from "./MyActiveTasks.vue?vue&type=script&lang=js"
import style0 from "./MyActiveTasks.vue?vue&type=style&index=0&id=73c325f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c325f7",
  null
  
)

export default component.exports